import { useMaintenance } from '@/context/MaintenanceContext'
import MaintenancePage from '@/components/maintenance/MaintenancePage'

const MaintenanceRoute = ({ children }) => {
  const { isMaintenanceMode, isAdminBypassed } = useMaintenance()

  if (isMaintenanceMode && !isAdminBypassed) {
    return <MaintenancePage />
  }

  return <>{children}</>
}

export default MaintenanceRoute
